import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  SimpleForm,
  Edit,
  TextInput,
  Create,
  TabbedForm,
  FormTab
} from "react-admin";

//import AvatarField from "./AvatarField";

export const NewsletterList = props => (
  <List title="Newsletter" {...props} exporter={false} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField label="Name" source="name" />
      <TextField label="Email" source="email" />
      <TextField label="Message" source="message" />
      <DateField
        label="Last Update"
        source="lastupdate"
        locales="lt"
      />
    </Datagrid>
  </List>
);

const NewsletterName = ({ record }) => {
  return <span>Contact {record ? `"${record.email}"` : ""}</span>;
};

export const NewsletterEdit = props => (
  <Edit title={<NewsletterName />} {...props}>
    <TabbedForm>
      <FormTab label="Contact information">
        <TextInput source="name" />
        <TextInput label="email" source="email" />
        <TextInput label="message" source="message" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const NewsletterCreate = props => (
  <Create title="Create Contact for Newsletter" {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput label="Email" source="email" />
      <TextInput label="Message" source="message" />
    </SimpleForm>
  </Create>
);


// WEBPACK FOOTER //
// ./src/newsletters.js